module.exports = __webpack_public_path__ + "img/1468959707.d1284384.jpg";